import React, { PropsWithChildren } from 'react';

import { useFirebaseSync } from './FirebaseProvider.utils';

interface Props {
	isLoggedIn: boolean;
}

function FirebaseProvider({ children, isLoggedIn }: PropsWithChildren<Props>): JSX.Element {
	useFirebaseSync({ isLoggedIn });

	return <>{children}</>;
}

export default FirebaseProvider;
